/*------------------------------------------------------------------------------------------------------------------------------
*
* Toggle Tabs
*
*/
// Changes the list 'button' menu
jQuery(document).ready(function($){
	$(".tabs li a").click(function() {
		
		// Active state for tabs
		$(".tabs li a").removeClass("active");
		$(this).addClass("active");
		
		// Active state for Tabs Content
		$(".tab_content_container > .tab_content_active").removeClass("tab_content_active").fadeOut(200);
		$(this.rel).fadeIn(500).addClass("tab_content_active");
		
	});	
});
// Changes the dropdown select menu
jQuery(document).ready(function($){
	$("select.tabs").change(function() {
		//Get the variable of the option selected in dropdown
        var selectValue = $('option:selected',this).attr('value');
		// Active state for Tabs Content
		$(".tab_content_container > .tab_content_active").removeClass("tab_content_active").fadeOut(200);
        $(selectValue).fadeIn(500).addClass("tab_content_active");
        
		
	});	
});

// Open and closes Menu
jQuery("#header-menu-container").click(function(){
    var hasClass;
    hasClass = jQuery("body").hasClass( "show-nav-main" );
    // First removes class if it is on
    jQuery("body").removeClass('show-nav-main');
    // If class not on the it will add
    if (hasClass === false) {
        jQuery("body").addClass( "show-nav-main" );
    }
    return false;
});



/*
Woocommerce
/
/
/
/
*/

jQuery(document).ready(function($) {
    // Listen for product added to cart event
    $(document.body).on('adding_to_cart', function() {
        console.log('Product added to cart event triggered'); // Log a message to the console
        // Check if the menu is currently closed
        var isMenuClosed = !jQuery("body").hasClass("show-woo-popup-cart");
        
        // Close the menu if it's open
        jQuery("body").removeClass("show-woo-popup-cart");
        
        // If the menu was closed, open it after a short delay
        if (isMenuClosed) {
            setTimeout(function() {
                jQuery("body").addClass("show-woo-popup-cart");
            }, 400); // Adjust the delay as needed (e.g., 1500 milliseconds)
        }
    });
	
    // Add click event listener for the close button
    $(document.body).on('click', 'button.cb-woo-popup-close', function() {
        jQuery("body").removeClass("show-woo-popup-cart");
    });
});


// This code works with the 'Add To Cart Ajax' in functions.php file. 
jQuery(function($) {

    $(".single_add_to_cart_button").addClass("ajax_add_to_cart");

    // Existing binding for quantity input on archive pages
    $(".post-type-archive-product").on("click", ".quantity input", function() {
        return false;
    });

    $(".archive").on("change input", ".quantity .qty", function() {
        var add_to_cart_button = $(this).parents(".product").find(".add_to_cart_button");
        add_to_cart_button.data("quantity", $(this).val());
        add_to_cart_button.attr("href", "?add-to-cart=" + add_to_cart_button.attr("data-product_id") + "&quantity=" + $(this).val());
    });

    $(".input-text.qty.text").bind('keyup mouseup', function() {
        var value = $(this).val();
        $(".product_quantity").val(value)
    });

    if (typeof wc_add_to_cart_params === 'undefined')
        return false;

    $(document).on('click', '.ajax_add_to_cart', function(e) {
        e.preventDefault();
        var $thisbutton = $(this);
        var $variation_form = $(this).closest('.variations_form');
        var var_id = $variation_form.find('input[name=variation_id]').val();
        $('.ajaxerrors').remove();
        var item = {},
            check = true;
        variations = $variation_form.find('select[name^=attribute]');
        if (!variations.length) {
            variations = $variation_form.find('[name^=attribute]:checked');
        }
        if (!variations.length) {
            variations = $variation_form.find('input[name^=attribute]');
        }
        variations.each(function() {
            var $this = $(this),
                attributeName = $this.attr('name'),
                attributevalue = $this.val(),
                index,
                attributeTaxName;
            $this.removeClass('error');
            if (attributevalue.length === 0) {
                index = attributeName.lastIndexOf('_');
                attributeTaxName = attributeName.substring(index + 1);
                $this
                    .addClass('required error')
                    .before('<div class="ajaxerrors"><p>Please select ' + attributeTaxName + '</p></div>')
                check = false;
            } else {
                item[attributeName] = attributevalue;
            }
        });
        if (!check) {
            return false;
        }

        if ($thisbutton.is('.ajax_add_to_cart')) {
            $thisbutton.removeClass('added');
            $thisbutton.addClass('loading');
            var product_id, quantity, data;

            if ($(this).parents(".variations_form")[0]) {
                // For variable products
                product_id = $variation_form.find('input[name=product_id]').val();
                quantity = $variation_form.find('input[name=quantity]').val();
                data = {
                    action: 'bodycommerce_ajax_add_to_cart_woo',
                    product_id: product_id,
                    quantity: quantity,
                    variation_id: var_id,
                    variation: item
                };
            } else {
                // For simple products, getting product_id from button's value attribute
                product_id = $thisbutton.val();  // Assuming the button's value attribute contains the product ID
                quantity = $(this).parent().find(".qty").val();
                data = {
                    action: 'bodycommerce_ajax_add_to_cart_woo_single',
                    product_id: product_id,
                    quantity: quantity
                };
            }

            $('body').trigger('adding_to_cart', [$thisbutton, data]);

            $.post(wc_add_to_cart_params.ajax_url, data, function(response) {
                if (!response)
                    return;
                var this_page = window.location.toString();
                this_page = this_page.replace('add-to-cart', 'added-to-cart');
                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                }
                if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
                    window.location = wc_add_to_cart_params.cart_url;
                    return;
                } else {
                    $thisbutton.removeClass('loading');
                    var fragments = response.fragments;
                    var cart_hash = response.cart_hash;
                    if (fragments) {
                        $.each(fragments, function(key) {
                            $(key).addClass('updating');
                        });
                    }
                    $('.shop_table.cart, .updating, .cart_totals').fadeTo('400', '0.6').block({
                        message: null,
                        overlayCSS: {
                            opacity: 0.6
                        }
                    });
                    $thisbutton.addClass('added');
                    if (fragments) {
                        $.each(fragments, function(key, value) {
                            $(key).replaceWith(value);
                        });
                    }
                    $('.widget_shopping_cart, .updating').stop(true).css('opacity', '1').unblock();
                    $('.shop_table.cart').load(this_page + ' .shop_table.cart:eq(0) > *', function() {
                        $('.shop_table.cart').stop(true).css('opacity', '1').unblock();
                        $(document.body).trigger('cart_page_refreshed');
                    });
                    $('.cart_totals').load(this_page + ' .cart_totals:eq(0) > *', function() {
                        $('.cart_totals').stop(true).css('opacity', '1').unblock();
                    });
                }
            }).always(function() {
                setTimeout(function() {
                    $thisbutton.fadeOut('slow', function() {
                        $(this).removeClass('added').fadeIn('slow');
                    });
                }, 3000);
            });
            return false;
        } else {
            return true;
        }
    });
    
});


function checkAvailabilityOnBackorder(productContainer) {
    // Get the product ID from the hidden input within the product container
    var productId = productContainer.find('input[name="product_id"]').val();
    
    // Parse the data-product_variations attribute within the product container
    var variationsDataAttr = productContainer.attr('data-product_variations');

    if (!variationsDataAttr) {
        console.log('Variations data not found for product ID:', productId);
        return; // Exit the function if variations data is not found
    }

    try {
        // Parse the variations data
        var variationsData = JSON.parse(variationsDataAttr);
    } catch (error) {
        console.error('Error parsing variations data for product ID:', productId, error);
        return; // Exit the function if there's an error parsing JSON
    }

    // Get the selected variation ID within the product container
    var selectedVariationId = productContainer.find('.variation_id').val();

    // Find the selected variation in the variations data
    var selectedVariation = variationsData.find(function(variation) {
        return variation.variation_id == selectedVariationId;
    });
    // console.log('selectedVariation: ', selectedVariation);
        
    // If variation is found and meets conditions, add the backorder message after the .woocommerce-variation-add-to-cart div
    if (selectedVariation && selectedVariation.backorders_allowed && !selectedVariation.availability_html.includes('in-stock')) {
        // This line code stops the message reprinting, it deletes option before adding new instance if it is chosen in select
        productContainer.find('.woocommerce-variation-add-to-cart').next('.backorder-message-product').remove();
        // Insert the backorder message after the .woocommerce-variation-add-to-cart div This message is passed from ACF in functions file
        productContainer.find('.woocommerce-variation-add-to-cart').after(acfData.backorder_message);
    } else {
        // Remove the backorder message if it exists
        productContainer.find('.woocommerce-variation-add-to-cart').next('.backorder-message-product').remove();
    }
        // If there is no variation ID or it is set to 0 then remove ability to buy until conditions are met
        if (selectedVariation && !selectedVariationId || selectedVariationId == 0 ){
            productContainer.find('.single_add_to_cart_button').removeClass('ajax_add_to_cart');
            productContainer.find('.single_add_to_cart_button').addClass('disabled wc-variation-is-unavailable');
    
    
        } else {
            productContainer.find('.single_add_to_cart_button').addClass('ajax_add_to_cart');
            productContainer.find('.single_add_to_cart_button').removeClass('disabled wc-variation-is-unavailable');
    
        }
    // If the item can't be backordered and it is out of stock, lock ability to buy by adding 'disabled' and removing 'ajax_add_to_cart'
    if (selectedVariation && !selectedVariation.backorders_allowed && selectedVariation.availability_html.includes('out-of-stock') ) {
        productContainer.find('.woocommerce-variation-add-to-cart').next('.out-of-stock-message-product').remove();
        productContainer.find('.woocommerce-variation-add-to-cart').after(acfData.out_of_stock_message);

        // Add class to the submit button
        productContainer.find('.single_add_to_cart_button').addClass('disabled wc-variation-is-unavailable');
        productContainer.find('.single_add_to_cart_button').removeClass('ajax_add_to_cart');
    } else {
        productContainer.find('.woocommerce-variation-add-to-cart').next('.out-of-stock-message-product').remove();
        // Remove class from the submit button
        if (selectedVariation && selectedVariationId ){
        productContainer.find('.single_add_to_cart_button').removeClass('disabled wc-variation-is-unavailable');
        }
    }

}



// Event listener for changes in select field representing product variations within each product container
jQuery(function($) {
    $('.variations_form').on('show_variation', function(event, variation) {
      // Get the form where the variation was selected
      var $form = $(this);
  
      // Find the parent product item — works for both archive and related sections
      var $productItem = $form.closest('li.product');
  
      // Find the image element outside the form in that product tile
      var $img = $productItem.find('.woocommerce-LoopProduct-link img');
  
      // If variation image exists, update the image
      if (variation && variation.image && variation.image.src) {
        console.log('✅ Variation image found:', variation.image.src);
        if ($img.length) {
          $img.attr('src', variation.image.src);
          $img.attr('srcset', variation.image.srcset || '');
          $img.attr('sizes', variation.image.sizes || '');
          $img.attr('alt', variation.image.alt || '');
        } else {
          console.warn('⚠️ Image element not found within product tile.');
        }
      }
    });
  
    // Optional: Reset to default image when variation is reset
    $('.variations_form').on('reset_data', function() {
      var $form = $(this);
      var $productItem = $form.closest('li.product');
      var $img = $productItem.find('.woocommerce-LoopProduct-link img');
  
      var originalSrc = $img.data('original-src');
      if (originalSrc) {
        $img.attr('src', originalSrc);
      }
    });
  
    // Save original image src for reset support
    $('li.product .woocommerce-LoopProduct-link img').each(function() {
      var $img = $(this);
      if (!$img.data('original-src')) {
        $img.data('original-src', $img.attr('src'));
      }
    });
  });
  

  // Think this is to do wioth Back Order showing up on variuation change
jQuery(function($) {
    // Run on page load so that if conditions met before select is chosen then it can still output checkAvailabilityOnBackorder() conditions
    $('.variations_form').each(function() {
        var productContainer = $(this).closest('.variations_form');
        // Store the reference to $(this) in a variable
        var $this = $(this);
        // Call the function to check availability on backorder for the current product container after a delay of 800 milliseconds
        setTimeout(function() {
            checkAvailabilityOnBackorder($this); // Use the stored reference
        }, 300);
    });

    // Event listener for changes in select field representing product variations within the current product container
    $('.variations_form select').on('change', function() {
        // Call the function to check availability on backorder for the current product container after a delay of 200 milliseconds
        var productContainer = $(this).closest('.variations_form');
        setTimeout(function() {
            checkAvailabilityOnBackorder(productContainer);
        }, 200);
    });
});






// Add LOADING CART gif whilst loading popup cart

jQuery(document).ready(function($) {
    // Show loading text when an Ajax request starts
    $(document).ajaxStart(function() {
        $('.mini-cart-loading-text').show();
    });

    // Hide loading text when all Ajax requests have completed
    $(document).ajaxStop(function() {
        $('.mini-cart-loading-text').hide();
    });
});




// This code loads different inmages pon archive page based on selected variation
jQuery(document).ready(function($) {
    $('.products .product').each(function() {
        var productContainer = $(this);
        var variationWrapper = productContainer.find('.variation-data');

        if (!variationWrapper.length) return;

        var data = variationWrapper.attr('data-product_variations');
        if (!data) return;

        try {
            var variations = JSON.parse(data);
            var allOutOfStock = variations.every(function(variation) {
                return variation.is_in_stock === false;
            });

            if (allOutOfStock) {
                var loopLink = productContainer.find('.woocommerce-LoopProduct-link');
                if (loopLink.length && loopLink.find('.outofstock').length === 0) {
                    loopLink.prepend('<span class="product-image-box outofstock">Out of Stock</span>');
                }
            }
        } catch (e) {
            console.error('Invalid variation data for product:', e);
        }
    });
});


// Changes price in new location above vairiations
jQuery(function($) {
    function attachVariationEvents($scope) {
        $scope.find('.variations_form').each(function() {
            var $form = $(this);
            var $productWrapper = $form.closest('.product');
            var $priceContainer = $productWrapper.find('.custom-variation-price').first();

            $form.off('found_variation reset_data');

            $form.on('found_variation', function(event, variation) {
                var priceToDisplay = '';
                if (variation && variation.price_html) {
                    priceToDisplay = variation.price_html;
                } else if (variation && variation.display_price) {
                    priceToDisplay = variation.display_price;
                }

                if (typeof priceToDisplay === 'number') {
                    priceToDisplay = `<span class="price"><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${priceToDisplay.toFixed(2)}</bdi></span></span>`;
                }

                $priceContainer.html(priceToDisplay);
            });

            $form.on('reset_data', function() {
                $priceContainer.html('');
            });

            var hasVariations = !!$form.data('product_variations');
            var allSelected = true;

            $form.find('select').each(function() {
                if (!$(this).val()) {
                    allSelected = false;
                }
            });

            if (hasVariations && allSelected) {
                $form.trigger('check_variations');
            }

            if (hasVariations && $form.data('product_variations').length === 1) {
                var variation = $form.data('product_variations')[0];
                var price = variation.price_html || variation.display_price;

                if (typeof price === 'number') {
                    price = `<span class="price"><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${price.toFixed(2)}</bdi></span></span>`;
                }

                if (typeof price === 'string' && price.indexOf('<span class="price">') !== -1) {
                    $priceContainer.html(price);
                } else {
                    $priceContainer.html('$' + price.toFixed(2));
                }
            }
        });
    }

    attachVariationEvents($(document));

    $(document.body).on('wc_fragments_loaded wc_fragment_refresh updated_cart_totals updated_checkout', function() {
        attachVariationEvents($(document));
    });

    $(document).on('quickview_loaded elementor/popup/show', function() {
        attachVariationEvents($(document));
    });

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if ($(node).find('.variations_form').length) {
                    attachVariationEvents($(node));
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});




/////////////////// END WOOCOMMERCE










 // AGE VERIFICATION POPUP
// This script creates all the functions to make the age verification popup work
jQuery(document).ready(function($){
    var agePopupTimeout;

    // Function to create the age verification popup
    function createAgePopup() {
        $('#cb-age').fadeIn(10).css('display', 'flex');
    }

    // Check if the cookie exists to determine if the age verification popup should be displayed
    if (!readCookie('ageVerified')) {
        agePopupTimeout = setTimeout(createAgePopup, 2000);
    }

    // Function to handle clicking 'Yeah' button
    $('.cb-age-btn.yes').click(function() {
        // Add a cookie to stop the popup from happening for 30 days
        createCookie('ageVerified', 'true', 30);
        $('#cb-age').fadeOut();
    });

    // Function to handle clicking 'Nah' button
    $('.cb-age-btn.no').click(function() {
        $('#cb-age').addClass('cb-age-under');
    });

    // Function to handle clicking 'Go Back' button
    $('.cb-age-back').click(function() {
        // Check if the browser has a history to go back to
        if (window.history.length > 1) {
            var previousUrl = document.referrer;
            var currentUrl = window.location.href;

            // Get the domain of the previous and current URLs
            var previousDomain = extractDomain(previousUrl);
            var currentDomain = extractDomain(currentUrl);

            // If the domains are different, go back to the previous URL
            // Otherwise, navigate to the fallback URL
            if (previousDomain !== currentDomain) {
                window.history.back();
            } else {
                window.location.href = 'https://www.abc.net.au/abckids';
            }
        } else {
            window.location.href = 'https://www.abc.net.au/abckids';
        }
    });

    // Function to create a cookie
    function createCookie(name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    // Function to read a cookie
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Function to erase a cookie
    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    // Function to extract domain from URL
    function extractDomain(url) {
        var domain;
        // Find & remove protocol (http, ftp, etc.) and get domain
        if (url.indexOf("://") > -1) {
            domain = url.split('/')[2];
        } else {
            domain = url.split('/')[0];
        }
        // Find & remove port number
        domain = domain.split(':')[0];
        return domain;
    }
}); 


// GOOGLE MAPS


            
 
(function($) {

    var global_markers = [];
    var global_infowindows = [];
    var global_position = [];
  
    /*
     *  new_map
     *
     *  This function will render a Google Map onto the selected jQuery element
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$el (jQuery element)
     *  @return	n/a
     */
  
    function new_map($el) {
  
        // var
        var $markers = $el.find('.marker');
  
  
        // vars
        var args = {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            // disable the default User Interface
            disableDefaultUI: true,
            // add back fullscreen, streetview, zoom
            zoomControl: true,
            streetViewControl: false,
            fullscreenControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": "20"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "color": "#fcfcfc"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "weight": "4"
                        },
                        {
                            "color": "#303030"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#1b1b1c"
                        },
                        {
                            "lightness": "0"
                        },
                        {
                            "saturation": "0"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#4e4e53"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "color": "#c1c1cc"
                        },
                        {
                            "lightness": "20"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "weight": "3"
                        },
                        {
                            "lightness": "-88"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#4e4e53"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#576f53"
                        }
                    ]
                },
                {
                    "featureType": "poi.school",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#4e4e53"
                        }
                    ]
                },
                {
                    "featureType": "poi.sports_complex",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#576f53"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#c1c1cc"
                        },
                        {
                            "lightness": "-20"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "lightness": "-20"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "color": "#000023"
                        },
                        {
                            "saturation": "0"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "weight": "0.01"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "weight": "3.00"
                        },
                        {
                            "color": "#000023"
                        },
                        {
                            "saturation": "-100"
                        },
                        {
                            "lightness": "100"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#456779"
                        },
                        {
                            "lightness": "0"
                        }
                    ]
                }
            ]
            
        };
  
  
        // create map	        	
        var map = new google.maps.Map($el[0], args);
  
  
        // add a markers reference
        map.markers = [];
  
  
        // add markers
        $markers.each(function() {
  
            add_marker($(this), map);
  
        });
  
  
        // center map
        center_map(map);
  
        // Toggles between infowindows
        for (var i = 0; i < global_markers.length; i++) {
            // Keep value of 'i' in event creation
            (function(i) {
                google.maps.event.addListener(global_markers[i], 'click', function() {
                    closeInfowindows();
                    global_infowindows[i].open(map, global_markers[i]);
                });
            }(i));
        }
  
        // return
        return map;
  
    }
  
    /*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$marker (jQuery element)
     *  @param	map (Google Map object)
     *  @return	n/a
     */
  
    function add_marker($marker, map) {
  
        // var
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
        // var for icon
        var icon = {
            url: $marker.attr('data-icon'), // url
            scaledSize: new google.maps.Size(50, 50), // experiment with these values until you're satisfied
            // origin: new google.maps.Point(0,0), // set the base origin
            // anchor: new google.maps.Point(0, 0) // set the base anchor
        };
  
        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: icon
        });
  
        // add to array
        map.markers.push(marker);
        global_markers.push(marker);
        global_position.push(latlng);
  
        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });
  
            global_infowindows.push(infowindow);
  
            // show info window when marker is clicked
            /* google.maps.event.addListener(marker, 'click', function() {
  
              infowindow.open( map, marker );
  
            }); */
        }
  
    }
  
    /*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	map (Google Map object)
     *  @return	n/a
     */
  
    function center_map(map) {
  
        // vars
        var bounds = new google.maps.LatLngBounds();
  
        // loop through all markers and create bounds
        $.each(map.markers, function(i, marker) {
  
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
  
            bounds.extend(latlng);
  
        });
  
        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else {
            // fit to bounds
            map.fitBounds(bounds);
        }
  
    }
  
    // Close infowindow function
    function closeInfowindows() {
        for (var x = 0; x < global_infowindows.length; x++) {
            global_infowindows[x].close();
        }
    }
  
    /*
     *  document ready
     *
     *  This function will render each map when the document is ready (page has loaded)
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	5.0.0
     *
     *  @param	n/a
     *  @return	n/a
     */
    // global var
    var map = null;
  
    $(document).ready(function() {
  
        $('.acf-map').each(function() {
  
            // create map
            map = new_map($(this));
  
        });
  
        $('button').on('click', function() {
            var idx = $(this).attr('data-marker');
            google.maps.event.trigger(global_markers[idx], 'click');
            console.log(global_markers[20]);
        });
    });
  
  })(jQuery);
  
  // Scroll to map when click on 'show on map' button
  jQuery(document).ready(function($){
  $(".map-btn").click(function() {
    $('html, body').animate({
        scrollTop: $(".acf-map").offset().top
    }, 500);
  });
  });